import { useEffect } from 'react';
import {
  UsersRequestParams,
  UsersResponse,
} from 'src/apis/organisation-service/types';
import { useAxios } from 'src/hooks/use-axios';
import urlTemplate from 'url-template';

type Options = {
  url: string;
  params?: UsersRequestParams;
};

export function useUsers({ url, params }: Options) {
  const users = useAxios(
    (axios, signal, { params }) =>
      axios.request<UsersResponse>({
        signal,
        url: urlTemplate.parse(url).expand({}),
        params,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    users.execute({ params });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return users;
}

export type UsersRequest = ReturnType<typeof useUsers>;
